import { css } from 'lit';
export const timerStyle = css ``;
//# sourceMappingURL=timer.style.js.map